import React, { useState, useEffect, useRef } from 'react';
import { List, Datagrid, TextField, FunctionField, SimpleList, useRefresh, SimpleForm, TextInput } from 'react-admin';
import {
    useMediaQuery, makeStyles, CircularProgress, Typography, Portal, Dialog, DialogActions,
    DialogTitle, DialogContent, Button, Checkbox, FormControlLabel, TextField as MuiTextField, FormControl, InputLabel, Select, MenuItem
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import moment from 'moment'
import CustomSearch from './components/CustomSearch';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import config from "./config.json";
import { Helmet } from "react-helmet";
// import FasTagCard from './images/fastagCard.png';
//import { useDispatch } from 'react-redux';
import { vehicleSvgs, hideName, hideVehicleNumber, hideMobileNumber } from "./sharedData";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CustomDatePicker from './components/CustomDatePicker';
import RaAutocompleteInput from './components/RaAutocompleteInput';
// import ParkSmartLogo from "./images/logo.png";
import ParkingSearchSelector from './components/ParkingSearchSelector'
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    tableTitle: {
        fontSize: 22,
        fontWeight: 500,
        display: "inline-block",
    },
    timeFilterContainer: {
        alignItems: "center",
        margin: customTheme.spacing(2, 2, 3),
    },
    outlinedInput: {
        padding: 0,
    },
    timeFilterButton: {
        width: "10%",
        minWidth: 85,
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
        marginBottom: 30,
        margin: "0 16px 30px"
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    removeMargin: {
        margin: 0,
    },
    statusIndicator: {
        display: "inline-block",
        width: 10,
        height: 10,
        borderRadius: 50,
        marginRight: 3
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
});

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

// const renderTagImagee = record => {
//     const issuerId = getFastagIssuerId(record);
//     const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;

//     if (typeof issuer === "string")
//         return <img src={`/images/${issuer.replace(/\s/g, "")}.png`} alt={issuer} style={{ width: 70, height: 30, borderRadius: 5, border: "1px solid #aaa", marginBottom: 5 }} />
//     else if (typeof record.tag_id === "string" && record.tag_id !== "")
//         return <img src={ParkSmartLogo} alt="ParkSmart" style={{ width: 44, borderRadius: 7, display: "block", margin: "auto", marginTop: 10 }} />
//     else
//         return null
// };

// const getFastagIssuerId = (tagId) => {
//     let tagIdBin = "";
//     for (let i = 0; i < tagId.length; i++) {
//         tagIdBin += (parseInt(tagId[i], 16).toString(2)).padStart(4, "0");
//     }
//     const issuerId = parseInt(tagIdBin.substr(43, 20), 2).toString();
//     return issuerId;
// };

// const renderVehicleType = row => (
//     row.vehicle_type ?
//         <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
//             <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 48 }} alt={row.vehicle_type_label} />
//             {/* row.vehicle_type_label */}
//         </div>
//         :
//         null
// );

// const renderBrand = row => row.brand ? row.brand : '-'
// const renderModel = row => row.model ? row.model : '-'
// const renderAmount = (row, fieldName) => (`₹ ${parseFloat(row[fieldName])}`);

const CATEGORY = "MONTHLY PASS REQUEST SECTION"

export const MonthlyPassRequest = (props) => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles()
    const location = useLocation()
    // const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchTypeState = ["Vehicle Number", "Name", "Mobile", "Pass Type"]
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");

    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    // useEffect(() => {

    // }, [currentParking]); // eslint-disable-line react-hooks/exhaustive-deps

    // const MonthlyPassRequestAction = (props) => {
    //     const {
    //         ...rest
    //     } = props;
    //     const {
    //         total,
    //         page,
    //         setPage,
    //         perPage,
    //         setPerPage,
    //         hasPreviousPage,
    //         hasNextPage
    //     } = useListContext();
    //     return (
    //         <TopToolbar {...sanitizeListRestProps(rest)} style={{ display: "block", marginTop: "22px" }}>
    //             <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
    //                 {total !== 0 && <CustomPagination setPage={setPage} page={page} total={total} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} perPage={perPage} setPerPage={setPerPage} />}
    //             </div>
    //             {/* {isSmallDevice && <div style={{ display: "flex", justifyContent: "flex-start" }}>
    //                 <div className='showResultTime' style={{ position: 'static', marginRight: 34 }}>
    //                     <p>Showing Results: Today 00:01am To Today {moment().format('LT')}</p>
    //                 </div>
    //             </div>} */}
    //         </TopToolbar>
    //     )
    // }

    React.useEffect(() => {
        eventTracker(CATEGORY, " MONTHLY PASS REQUEST")
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            </div>

            <List style={{ marginTop: 20 }}
                {...props}
                empty={false}
                sort={{ field: 'created_on', order: 'DESC' }}
                filter={filter}
                title="Monthly Pass Request"
                bulkActionButtons={false}
                exporter={false}
                actions={false}
                pagination={<CustomPagination />}
            >
                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => hideVehicleNumber(record.vehicle_number.toUpperCase())}
                        secondaryText={record => (<div>
                            {record.name && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideName(record.name)}</div>}
                            {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{hideMobileNumber(record.mobile)}</div>}
                            {record.pass_type && <div><span style={{ color: "#5a5a5a" }}>Pass Type: </span>{record.pass_type}</div>}
                            {record.created_on && <div><span style={{ color: "#5a5a5a" }}>Request At: </span>{renderTime(record["created_on"])}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            {!viewOnly && <RequestStatusField {...props} record={record} label="Status" source="status" />}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid className={!viewOnly ? "monthlyPassRequestDataGrid" : ""} component={ScrollableTable}>
                        <VehicleType {...props} label="Vehicle Number" source="vehicle_number" />
                        <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />
                        <FunctionField source="mobile" label="Mobile" render={record => record && record["mobile"] && record["mobile"] !== null ? hideMobileNumber(record.mobile): "-"} />
                        <TextField source="pass_type" label="Pass Type" />
                        <TextField source="parking_name" label="Parking Name" />
                        <FunctionField source="created_on" label="Request At" render={record => record && renderTime(record["created_on"])} sortable={true} />
                        {!viewOnly && <FunctionField className="ListIconsContainerMonthlyRequest" render={record => record &&
                            <div className="ListIcons">
                                <FunctionField source="created_on" label="Request At" render={record => record && record.paid ? <RequestStatusFieldPaid label="Status" source="status" record={record} /> : record ? <RequestStatusField {...props} label="Status" source="status" record={record} /> : null} />
                            </div>
                        } />}


                    </Datagrid>
                }
            </List>
        </div >
    )
};

function VehicleType(props) {

    const { record } = props;
    if (!record) return null
    return (
        <>
            {
                record.vehicle_number ?
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                        <img src={vehicleSvgs[record.vehicle_type]} style={{ width: 25, height: 25, marginRight: 10 }} alt={record.vehicle_type_label} />
                        <p>{hideVehicleNumber(record.vehicle_number)}</p>
                    </div> : null
            }

        </>
    );
}

// function RequestStatusField(props) {

//     const { record, source } = props;
//     return (
//         <>
//             {
//                 record[source] === -1 && <div style={{ display: "flex", columnGap: 10 }}>
//                     <div onClick={() => openDialog(1)} className="iconButton-square" style={{ minWidth: 50, minHeight: 32, backgroundColor: customTheme.palette.primary.main + "29" }}><CheckIcon style={{ color: customTheme.palette.primary.main }} /></div>
//                     <div onClick={() => openDialog(0)} className="iconButton-square" style={{ minWidth: 50, minHeight: 32, backgroundColor: customTheme.palette.error.main + "29" }}><CloseIcon style={{ color: customTheme.palette.error.main }} /></div>
//                 </div>
//             }

//         </>
//     );
// }

function RequestStatusField(props) {
    const classes = useStyles();
    const { record, source } = props;

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const refresh = useRefresh();
    //const notify = useNotify();
    //const dispatch = useDispatch();

    const [resolved, setResolved] = React.useState(null);
    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [rfid, setRfid] = useState();

    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [amountText, setAmountText] = useState(0);
    const [months, setMonths] = useState(1);
    const [gstToggle, setGstToggle] = useState(false);
    const [gstAmount, setGstAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [nfcCardCharges, setnfcCardCharges] = useState(0)
    const [rfidCharges, setrfidCharges] = useState(0)


    //const [limitValidity, setLimitValidity] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [paymentMethod, setPaymentMethod] = useState('Digital');

    const [selectedOptions, setSelectedOptions] = useState("")
    const surfaceId = useRef("")
    const [emailAddress, setEmailAddress] = useState(record.email ? record.email : "")
    const [nfcCard] = useState(record.nfc_uid != null && record.nfc_uid !== "" ? `${record.surface_id} - ${record.nfc_uid}` : "")
    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    }

    const openDialog = state => {
        setResolved(state);
        setDialogVisible(true);
        setRfid("");

    };

    const closeDialog = () => {
        setDialogVisible(false);
        //setSelectedOptions("")
    };

    const handleUpdate = (event) => {
        event.preventDefault();

        if (resolved === 1) {

            let emailRegex = /\S+@\S+\.\S+/;

            if ((record.rfid == null || record.rfid === "") && (rfid == null || rfid === "")) {
                notify('RFID is required', 'warning');
                return;
            }
            if (emailAddress === "") {
                return notify("Please enter your email address.", "warning")
            }
            if (!emailRegex.test(emailAddress)) {
                return notify("Invalid email address.", "warning")
            }

            if (startDate == null || startDate === '') {
                notify('Start Date is required', 'warning');
                return;
            }

            if (amountText == null || amountText === '' || isNaN(amountText) || parseFloat(amountText) < 0) {
                notify('Amount is required', 'warning');
                return;
            }

            if (
                totalAmount == null ||
                totalAmount === '' ||
                isNaN(totalAmount) ||
                parseFloat(totalAmount) < 0
            ) {
                notify('Amount is required', 'warning');
                return;
            }

            if (paymentMethod == null || paymentMethod === '') {
                notify('Payment Method is required', 'warning');
                return;
            }

        }

        setLoading(true);

        if (resolved !== 1) {
            fetch(`${config.HOST_NAME}/crm/v3/issueMonthlyPass/${record.id}/decline`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    user_id: sessionStorage.getItem("user_id"),
                }),
            })
                .then((response) => response.json())
                .then((json) => {
                    setLoading(false)
                    if (json.success) {
                        notify(json.message, 'success');
                    } else {
                        notify(json.message, 'warning');
                    }
                    refresh();
                })
                .catch((e) => {
                    setLoading(false);
                    notify('Check your internet connection', 'warning');
                })
        }
        if (resolved === 1 && paymentMethod === "Digital") {
            //payment process
            const params = {
                id: record.id,
                access_key_id: record.access_key_id,
                name: record.name,
                mobile_number: record.mobile,
                vehicle_number: record.vehicle_number,
                vehicle_type: record.vehicle_type,
                rfid: record.rfid ? record.rfid : rfid,
                price: totalAmount,
                monthly_pass_amount: Number(amountText),
                payment_method: paymentMethod,
                expiry_date: moment(startDate).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD 23:59:59'),
                start_date: startDate ? startDate : null,
                nfc_uid: selectedOptions != null && selectedOptions !== "" ? selectedOptions : record.nfc_uid,
                nfc_surface_id: surfaceId != null && surfaceId.current !== "" ? surfaceId.current : record.surface_id,
                pass_type: record.pass_type,
                email_address: emailAddress
            }

            closeDialog();
            closePaymentFailedDialog();
            fetch(`${config.HOST_NAME}/crm/v3/issueMonthlyPass/initiateMonthlyPassPayment/jammu`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    price: totalAmount,
                    vehicle_number: params.vehicle_number,
                    vehicle_type: params.vehicle_type,
                    expiry_date: params.expiry_date,
                    mobile: params.mobile_number,
                    pass_type: params.pass_type,
                    access_key_id: params.access_key_id,
                    start_date: params.start_date,
                    nfc_uid: params.nfc_uid
                }),
            })
                .then((response) => {
                    saveTokens(response)
                    return response.json()
                })
                .then((json) => {
                    if (json.success) {
                        const order = json.data.order;
                        var options = {
                            description: 'Permit Charges',
                            currency: order.currency,
                            key: config.RAZOR_PAY_KEY_ID,
                            amount: order.amount,
                            name: 'ParkSmart',
                            order_id: order.id,
                            notes: {
                                nfc_uid: params.nfc_uid ? params.nfc_uid : "",
                                parking_name: json.data.parking_name,
                            },
                            prefill: {
                                name: params.name,
                                contact: params.mobile,
                            },
                            theme: {
                                color: customTheme.palette.primary.main,
                            },
                            modal: {
                                ondismiss: () => {
                                    setLoading(false);
                                    const description = 'Payment is cancelled by user';
                                    setPaymentFailedDialog(description);
                                },
                            },
                            handler: (checkoutData) => {
                                fetch(`${config.HOST_NAME}/crm/v3/issueMonthlyPass/verifyMonthlyPassPayment/jammu`, {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        ...checkoutData,
                                        transaction_id: json.data.transaction_id,
                                        ...params,
                                    }),
                                })
                                    .then((response) => {
                                        saveTokens(response)
                                        return response.json()
                                    })
                                    .then((json) => {
                                        setLoading(false);
                                        if (json.success) {
                                            notify('Payment Successful', 'success');
                                            refresh();
                                            //refreshPendingRequestCount();
                                        } else {
                                            setPaymentFailedDialog(json.message);
                                        }
                                    })
                                    .catch((error) => {
                                        setLoading(false);
                                        setPaymentFailedDialog('Could not verify Payment');
                                    })
                            },
                        }
                        const razorpay = new window.Razorpay(options);
                        razorpay.on('payment.failed', function ({ error }) {
                            setLoading(false);
                            let description;
                            if (isJsonString(error.description)) {
                                const errorObj = JSON.parse(error.description)
                                if (errorObj.error) {
                                    description = errorObj.error.description;
                                } else {
                                    description = errorObj.description;
                                }
                            } else {
                                description = error.description;
                            }
                            setPaymentFailedDialog(description)
                        })

                        razorpay.open();
                    } else {
                        setLoading(false);
                        notify(json.message, 'warning');
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                    notify('Check your internet connection', 'warning');
                })
        }
    }

    return (
        <>
            <Helmet>
                <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
            </Helmet>
            <div style={{ marginTop: isSmallDevice ? 5 : 0, textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice || record[source] === -1 ? "flex" : "block", flex: 1, columnGap: 8 }}>
                {loading ?
                    <CircularProgress color="secondary" size={20} />
                    : (record[source] === -1 ?
                        <>
                            <div onClick={() => openDialog(1)} className="iconButton-square" style={{ minWidth: 50, minHeight: 32, backgroundColor: customTheme.palette.primary.main + "29" }}><CheckIcon style={{ color: customTheme.palette.primary.main }} /></div>
                            <div onClick={() => openDialog(0)} className="iconButton-square" style={{ minWidth: 50, minHeight: 32, backgroundColor: customTheme.palette.error.main + "29" }}><CloseIcon style={{ color: customTheme.palette.error.main }} /></div>
                        </>
                        :
                        <>
                            <Typography style={{ fontWeight: "bold", color: record[source] === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main }}>{record[source] === 1 ? "Accepted" : record[source] === 0 && "Declined"}</Typography>
                            {/* {record.crm_user_id && record.crm_username && `by ${record.crm_username}`} */}
                        </>
                    )}

                <Portal>
                    <Dialog
                        open={!!paymentFailedDialog}
                        onClose={closePaymentFailedDialog}
                        classes={{ paper: classes.dialogPaper }}
                    >
                        <DialogTitle style={{ color: customTheme.palette.error.main }}>
                            <div style={{ fontSize: 16, textAlign: 'center' }}>
                                Payment Failed!
                            </div>
                        </DialogTitle>
                        <DialogContent
                            style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}
                        >
                            Description: {paymentFailedDialog}
                        </DialogContent>
                        <DialogActions
                            style={{ display: 'flex', justifyContent: 'space-evenly' }}
                        >
                            <Button
                                className={classes.dialogButton}
                                variant="outlined"
                                color="default"
                                onClick={closePaymentFailedDialog}
                            >
                                Cancel
                            </Button>
                            <Button
                                disableElevation
                                className={classes.dialogButton}
                                variant="contained"
                                color="secondary"
                                onClick={handleUpdate}
                            >
                                Retry
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Portal>

                <Dialog fullWidth open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaperBig }}>
                    {resolved !== 1 || (["Society", "Hybrid"].includes(record.parking_type) && record.rfid) ?
                        <DialogContent>
                            Are you sure you want to{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                {resolved === 1 ? 'Accept' : 'Decline'}
                            </span>{' '}
                            this request?
                        </DialogContent>
                        :
                        <SimpleForm style={{ padding: '10px 22px' }} toolbar={false}>
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 20 }}>
                                <div style={{ display: 'flex', alignItems: "center" }}>
                                    <img src={vehicleSvgs[record.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8, overflow:"visible" }} alt={record.vehicle_type_label} />
                                    <p style={{ fontFamily: "Poppins-Medium", color: "#707683", fontSize: 15, textTransform: "uppercase" }}>{record.vehicle_number}</p>

                                </div>

                                {
                                    record.chassis_number && record.chassis_number !== null && record.chassis_number !== "" && <div style={{ display: 'flex', alignItems: "center" }}>
                                        <p style={{ fontFamily: "Poppins-Medium", color: "#212121", fontSize: 15, marginRight: 8 }}>Chassis Number:</p>
                                        <p style={{ fontFamily: "Poppins-Medium", color: "#707683", fontSize: 15, textTransform: "uppercase" }}>{record.chassis_number}</p>
                                    </div>
                                }
                            </div>
                            <TextInput
                                source="access_key_id"
                                defaultValue={record.access_key_id}
                                style={{ display: 'none' }}
                            />

                            <div style={{ width: '100%' }}>


                                <>
                                    {
                                        record.rfid != null && record.rfid !== "" ?
                                            <div>
                                                <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Assigned RFID Tag</div>
                                                <MuiTextField
                                                    variant='outlined'
                                                    value={record.rfid}
                                                    size="small"
                                                    style={{ marginBottom: 15, marginTop: 7, width: "260px" }}
                                                    disabled
                                                />
                                            </div> :
                                            <div>
                                                <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>RFID Tag*</div>
                                                <RaAutocompleteInput
                                                    source="rfid"
                                                    resourceParam="search"
                                                    resourcePath="rfidInventory"
                                                    filter={{ available: true }}
                                                    label=""
                                                    getOptionValue={(option) => option['rfid']}
                                                    getOptionLabel={(option) =>
                                                        `${option['tag_id']} - ${option['rfid']}`
                                                    }
                                                    useAccessKeyId={true}
                                                    onSelect={(value) => setRfid(value)}
                                                    style={{ marginTop: 7, marginBottom: 15 }}
                                                />
                                            </div >
                                    }
                                </>

                                {
                                    record.nfc_uid ?
                                        <div>
                                            <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Assigned NFC Card</div>
                                            <MuiTextField
                                                variant='outlined'
                                                value={nfcCard}
                                                size="small"
                                                style={{ marginBottom: 15, marginTop: 7, width: "260px" }}
                                                disabled
                                            />
                                        </div>
                                        :
                                        <div style={{ width: "100%" }}>
                                            <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Select NFC Card*</div>
                                            <RaAutocompleteInput
                                                source="search"
                                                resourceParam="search"
                                                filter={{ available: true }}
                                                customSort={["surface_id", "ASC"]}
                                                resourcePath="cardsInventory"
                                                label=""
                                                getOptionValue={(option) => {
                                                    //setSurfaceId(option['surface_id'])
                                                    surfaceId.current = option['surface_id']
                                                    return option['nfc_uid']
                                                }}
                                                getOptionLabel={(option) =>
                                                    `${option['surface_id']} - ${option['nfc_uid']}`
                                                }
                                                onSelect={(value) => setSelectedOptions(value)}
                                                style={{ marginTop: 7, marginBottom: 15 }}
                                            />
                                        </div>
                                }

                                {/* here to add valid */}
                                {
                                    record.parking_type !== "Society" &&

                                    <div>
                                        <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Email Address*</div>
                                        <MuiTextField
                                            variant='outlined'
                                            value={emailAddress}
                                            onChange={(e) => setEmailAddress(e.target.value)}
                                            size="small"
                                            style={{ marginBottom: 15, marginTop: 7 }}
                                        />
                                        <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Start Date*</div>

                                        <CustomDatePicker
                                            style={{ marginTop: 7, marginBottom: 15 }}
                                            startDate={startDate}
                                            setStartDate={(val) => setStartDate(val)}
                                        />
                                        {
                                            (rfid || record.rfid) &&

                                            <ValidityAmountInputForMonthlyPassRequest
                                                accessKeyId={record.access_key_id}
                                                vehicle_type={record.vehicle_type}
                                                amountText={amountText}
                                                setAmountText={(val) => setAmountText(val)}
                                                gstToggle={gstToggle}
                                                setGstToggle={(val) => setGstToggle(val)}
                                                gstAmount={gstAmount}
                                                setGstAmount={(val) => setGstAmount(val)}
                                                months={months}
                                                setMonths={(val) => setMonths(val)}
                                                totalAmount={totalAmount}
                                                setTotalAmount={(val) => setTotalAmount(val)}
                                                paymentMethod={paymentMethod}
                                                setPaymentMethod={(val) => setPaymentMethod(val)}
                                                applyNfcCharges={record.nfc_uid ? false : true}
                                                nfcCardCharges={nfcCardCharges}
                                                rfid={record.rfid ? record.rfid : rfid}
                                                rfidCharges={rfidCharges}
                                                selectedOptions={selectedOptions}
                                                setnfcCardCharges={(val) => setnfcCardCharges(val)}
                                                setrfidCharges={(val) => setrfidCharges(val)}
                                            />
                                        }

                                    </div>
                                }
                                <div style={{ width: "100%", borderBottom: "1px solid #DEDEDE" }}></div>
                            </div >
                        </SimpleForm >
                    }

                    <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={closeDialog} variant='contained' disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }}>Cancel</Button>
                        <Button
                            className={resolved !== 1 ? classes.errorText : null}
                            variant='contained'
                            onClick={handleUpdate}
                            disableElevation
                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", color: "#FFFF", backgroundColor: resolved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main, }}
                        >
                            {resolved === 1
                                ? paymentMethod === 'Digital'
                                    ? 'Pay'
                                    : 'Accept'
                                : 'Decline'}
                        </Button>
                    </DialogActions>
                </Dialog >
            </div >
        </>
    );
}

function ValidityAmountInputForMonthlyPassRequest(props) {
    //const notify = useNotify();

    const {
        accessKeyId, vehicle_type, amountText, setAmountText, months, setMonths, gstToggle,
        setGstToggle, gstAmount, setGstAmount, totalAmount, setTotalAmount, applyNfcCharges, nfcCardCharges, rfid, selectedOptions, rfidCharges, setnfcCardCharges, setrfidCharges
    } = props



    const handleAmountChange = (event) => {
        if (!isNaN(event.target.value)) {
            setAmountText(event.target.value);
        }
    }

    const incrementMonth = () => {
        setMonths(months + 1);
    }

    const decrementMonth = () => {
        if (months > 1) setMonths(months - 1);
    }

    const gstHandler = () => {
        setGstToggle(!gstToggle);

    }

    useEffect(() => {
        if (gstToggle && rfid) {
            setGstAmount((9 / 100) * (Number(amountText) + Number(rfidCharges)) + (9 / 100) * (Number(amountText) + Number(rfidCharges)));
        }
        if (gstToggle && amountText && rfid) {
            setTotalAmount(((Number(amountText) + Number(rfidCharges)) + Number(gstAmount)));
        }
        if (!gstToggle && amountText && rfid) {
            setTotalAmount((Number(amountText) + Number(rfidCharges)));
        }


        // WITH NFC CHARGES
        if (gstToggle && applyNfcCharges && rfid) {

            if (amountText && selectedOptions && rfid) {
                setGstAmount((9 / 100) * (Number(amountText) + Number(nfcCardCharges) + Number(rfidCharges)) + (9 / 100) * (Number(amountText) + Number(nfcCardCharges) + Number(rfidCharges)));
            }
        }
        if (gstToggle && amountText && applyNfcCharges && rfid) {

            if (amountText && selectedOptions && rfid) {
                setTotalAmount(((Number(amountText) + Number(nfcCardCharges) + Number(rfidCharges)) + Number(gstAmount)));
            }
        }
        if (!gstToggle && amountText && applyNfcCharges && selectedOptions && rfid) {
            if (amountText && nfcCardCharges && rfid) {
                setTotalAmount((Number(amountText) + Number(nfcCardCharges) + Number(rfidCharges)));
            }
        }


    }, [gstToggle, amountText, selectedOptions, rfid, rfidCharges, nfcCardCharges, totalAmount, gstAmount])  // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (accessKeyId) {
            fetch(`${config.HOST_NAME}/crm/v3/parkings?user_id=${sessionStorage.getItem("user_id")}&filter=${JSON.stringify({ id: [accessKeyId], includeSocieties: true })}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                }
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {

                        if (json.success && json.data[0] && json.data[0].features && json.data[0].features.monthly_pass) {
                            if (vehicle_type === "4") {
                                setAmountText(json.data[0].features.monthly_pass.pass_types.Car[0].price ? json.data[0].features.monthly_pass.pass_types.Car[0].price : 0)
                                setnfcCardCharges(json.data[0].features.monthly_pass.nfc_card_charges ? json.data[0].features.monthly_pass.nfc_card_charges_car : 0)
                                setrfidCharges(json.data[0].features.monthly_pass.rfid_charges ? json.data[0].features.monthly_pass.rfid_charges_car : 0)
                            }
                            if (vehicle_type === "2") {
                                setAmountText(json.data[0].features.monthly_pass.pass_types.Scooter[0].price ? json.data[0].features.monthly_pass.pass_types.Scooter[0].price : 0)
                                setrfidCharges(json.data[0].features.monthly_pass.rfid_charges ? json.data[0].features.monthly_pass.rfid_charges_scooter : 0)
                                setnfcCardCharges(json.data[0].features.monthly_pass.nfc_card_charges ? json.data[0].features.monthly_pass.nfc_card_charges_scooter : 0)
                            }
                        } else {
                            notify("Monthly pass details not available", "info");
                        }
                    } else {
                        notify(json.message, "warning");
                    }
                })
                .catch(error => {
                    notify("Something went wrong", "warning");
                    console.log(error);
                });
        }
    }, [accessKeyId]); // eslint-disable-line react-hooks/exhaustive-deps



    return (
        <div style={{ width: '100%', marginBottom: 15 }}>
            <div
                className="grid-250"
                style={{ marginTop: 8, alignItems: 'flex-end' }}
            >
                <div>
                    <div className="formLabel-regular" style={{ marginBottom: 3 }}>
                        Amount*
                    </div>
                    <MuiTextField
                        value={amountText}
                        onChange={handleAmountChange}
                        label=""
                        variant="outlined"
                        size="small"
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: 10,
                        marginTop: 8,
                    }}
                >
                    <Button
                        onClick={decrementMonth}
                        style={{
                            backgroundColor: '#aaa',
                            color: '#fff',
                            minWidth: 35,
                            width: '20%',
                            height: 38,
                            opacity: 0.6,
                        }}
                        disabled={months <= 1}
                    >
                        <RemoveIcon style={{ fontSize: 23 }} />
                    </Button>
                    <div
                        style={{
                            border: '1px solid #bbb',
                            color: '#666',
                            padding: '7px 12%',
                            borderRadius: 5,
                        }}
                    >
                        {months === 1 ? '1 Month' : `${months} Months`}
                    </div>
                    <Button
                        onClick={incrementMonth}
                        style={{
                            backgroundColor: '#aaa',
                            color: '#fff',
                            minWidth: 35,
                            width: '20%',
                            height: 38,
                            opacity: 0.6,
                        }}
                        disabled
                    >
                        <AddIcon style={{ fontSize: 21 }} />
                    </Button>
                </div>
            </div>
            <FormControlLabel
                className="formLabel-regular"
                checked={gstToggle}
                onChange={gstHandler}
                control={<Checkbox color="primary" />}
                label="Add GST"
                style={{ marginTop: 5 }}
            />
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '80% 20%',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    maxWidth: 500,
                }}
            >
                { // WITH OUT NFC CHARGES
                    rfid && !selectedOptions ? <>
                        <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                            Monthly Pass Charges
                        </Typography>
                        <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                            ₹
                            {amountText}
                        </Typography>
                        {
                            rfid && <>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    RFID Charges
                                </Typography>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    ₹{rfidCharges ? rfidCharges : 0}
                                </Typography>
                            </>
                        }
                        {
                            gstToggle && rfid && <>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    CGST 9%
                                </Typography>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    ₹{((9 / 100) * (Number(amountText) + Number(rfidCharges)))}
                                </Typography>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    SGST 9%
                                </Typography>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    ₹{((9 / 100) * (Number(amountText) + Number(rfidCharges)))}
                                </Typography>
                            </>
                        }
                        {/* {
                            !gstToggle && rfid && <>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    CGST 9%
                                </Typography>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    ₹{((9 / 100) * (Number(amountText)))}
                                </Typography>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    SGST 9%
                                </Typography>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    ₹{((9 / 100) * (Number(amountText)))}
                                </Typography>
                            </>
                        } */}
                        <Typography style={{ fontSize: 15 }}>Total</Typography>
                        <Typography style={{ fontSize: 15 }}>
                            ₹{' '}
                            {totalAmount}
                        </Typography>

                    </> :
                        // WITH NFC CHARGES
                        <>
                            <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                Vehicle Charges
                            </Typography>
                            <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                ₹
                                {amountText}
                            </Typography>
                            {selectedOptions && <>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    NFC Card Charges
                                </Typography>
                                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                    ₹{nfcCardCharges}
                                </Typography>
                            </>}
                            {
                                rfid && <>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        RFID Charges
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        ₹{rfidCharges}
                                    </Typography>
                                </>
                            }
                            {
                                gstToggle && !selectedOptions && rfid && <>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        CGST 9%
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        ₹{((9 / 100) * (Number(amountText) + Number(rfidCharges)))}
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        SGST 9%
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        ₹{((9 / 100) * (Number(amountText) + Number(rfidCharges)))}
                                    </Typography>
                                </>
                            }
                            {
                                gstToggle && selectedOptions && rfid && <>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        CGST 9%
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        ₹{((9 / 100) * (Number(amountText) + Number(nfcCardCharges) + Number(rfidCharges)))}
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        SGST 9%
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        ₹{((9 / 100) * (Number(amountText) + Number(nfcCardCharges) + Number(rfidCharges)))}
                                    </Typography>
                                </>
                            }
                            <Typography style={{ fontSize: 15 }}>Total Amount</Typography>
                            <Typography style={{ fontSize: 15 }}>
                                ₹{' '}
                                {totalAmount}
                            </Typography>

                        </>
                }
            </div>
        </div>
    )
}


function RequestStatusFieldPaid(props) {
    const classes = useStyles();
    const { record, source } = props;

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const refresh = useRefresh();
    //const notify = useNotify();

    const [resolved, setResolved] = React.useState(null);
    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [rfid, setRfid] = useState();

    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [amountText] = useState(0);

    const [startDate, setStartDate] = useState(new Date());

    const [selectedOptions, setSelectedOptions] = useState("")
    const surfaceId = useRef("")
    const [emailAddress, setEmailAddress] = useState(record.email ? record.email : "")


    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    }

    const openDialog = state => {
        setResolved(state);
        setDialogVisible(true);
        setRfid("");
    };

    const closeDialog = () => {
        setDialogVisible(false);
        //setSelectedOptions("")
    };


    const handleUpdate = (event) => {
        event.preventDefault();

        if (resolved === 1) {

            let emailRegex = /\S+@\S+\.\S+/;

            if ((record.rfid == null || record.rfid === "") && (rfid == null || rfid === "")) {
                notify('RFID is required', 'warning');
                return;
            }

            // if ((selectedOptions == null || selectedOptions === '') && (nfcCard == null || nfcCard === '')) {
            //     notify('NFC Card is required', 'warning');
            //     return;
            // }
            if (emailAddress === "") {
                return notify("Please enter your email address.", "warning")
            }
            if (!emailRegex.test(emailAddress)) {
                return notify("Invalid email address.", "warning")
            }

            if (startDate == null || startDate === '') {
                notify('Start Date is required', 'warning');
                return;
            }

            if (amountText == null || amountText === '' || isNaN(amountText) || parseFloat(amountText) < 0) {
                notify('Amount is required', 'warning');
                return;
            }

        }

        setLoading(true);
        if (resolved !== 1) {
            fetch(`${config.HOST_NAME}/crm/v3/issueMonthlyPass/${record.id}/decline`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
                body: JSON.stringify({
                    user_id: sessionStorage.getItem("user_id"),
                }),
            })
                .then((response) => {
                    saveTokens(response)
                    return response.json()
                })
                .then((json) => {
                    setLoading(false)
                    if (json.success) {
                        notify(json.message, 'success');
                    } else {
                        notify(json.message, 'warning');
                    }
                    refresh();
                })
                .catch((e) => {
                    setLoading(false);
                    notify('Check your internet connection', 'warning');
                })
        }

        if (resolved === 1) {
            //payment process
            const params = {
                id: record.id,
                access_key_id: record.access_key_id,
                name: record.name,
                mobile_number: record.mobile,
                vehicle_number: record.vehicle_number,
                vehicle_type: record.vehicle_type,
                rfid: record.rfid ? record.rfid : rfid,
                price: Number(record.rfid_amount) + Number(record.monthly_pass_amount) + Number(record.nfc_amount !== "" || record.nfc_amount != null ? record.nfc_amount : 0),
                monthly_pass_amount: record.monthly_pass_amount ? Number(record.monthly_pass_amount) : null,
                expiry_date: moment(startDate).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD 23:59:59'),
                start_date: startDate ? startDate : null,
                nfc_uid: selectedOptions != null && selectedOptions !== "" ? selectedOptions : record.nfc_uid,
                nfc_surface_id: surfaceId != null && surfaceId.current !== "" ? surfaceId.current : record.surface_id,
                pass_type: record.pass_type,
                email_address: emailAddress
            }

            fetch(`${config.HOST_NAME}/crm/v3/assignMonthlyPass/jammu`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
                body: JSON.stringify(params)
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        setLoading(false)
                        notify(json.message, "success");
                        closeDialog()
                        refresh()
                    } else {
                        notify(json.message, "warning");
                        setLoading(false)
                    }
                })
                .catch(error => {
                    setLoading(false)
                    notify("Something went wrong", "warning");
                    console.log(error);
                });

        }
    }

    return (
        <>
            <div style={{ marginTop: isSmallDevice ? 5 : 0, textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice || record[source] === -1 ? "flex" : "block", flex: 1, columnGap: 8 }}>
                {loading ?
                    <CircularProgress color="secondary" size={20} />
                    : (record[source] === -1 ?
                        <>
                            <div onClick={() => openDialog(1)} className="iconButton-square" style={{ minWidth: 50, minHeight: 32, backgroundColor: customTheme.palette.primary.main + "29" }}><CheckIcon style={{ color: customTheme.palette.primary.main }} /></div>
                            <div onClick={() => openDialog(0)} className="iconButton-square" style={{ minWidth: 50, minHeight: 32, backgroundColor: customTheme.palette.error.main + "29" }}><CloseIcon style={{ color: customTheme.palette.error.main }} /></div>
                        </>
                        :
                        <>
                            <Typography style={{ fontWeight: "bold", color: record[source] === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main }}>{record[source] === 1 ? "Accepted" : record[source] === 0 && "Declined"}</Typography>
                            {/* {record.crm_user_id && record.crm_username && `by ${record.crm_username}`} */}
                        </>
                    )}

                <Portal>
                    <Dialog
                        open={!!paymentFailedDialog}
                        onClose={closePaymentFailedDialog}
                        classes={{ paper: classes.dialogPaper }}
                    >
                        <DialogTitle style={{ color: customTheme.palette.error.main }}>
                            <div style={{ fontSize: 16, textAlign: 'center' }}>
                                Payment Failed!
                            </div>
                        </DialogTitle>
                        <DialogContent
                            style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}
                        >
                            Description: {paymentFailedDialog}
                        </DialogContent>
                        <DialogActions
                            style={{ display: 'flex', justifyContent: 'space-evenly' }}
                        >
                            <Button
                                className={classes.dialogButton}
                                variant="outlined"
                                color="default"
                                onClick={closePaymentFailedDialog}
                            >
                                Cancel
                            </Button>
                            <Button
                                disableElevation
                                className={classes.dialogButton}
                                variant="contained"
                                color="secondary"
                                onClick={handleUpdate}
                            >
                                Retry
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Portal>

                <Dialog fullWidth open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaperBig }}>
                    {resolved !== 1 || (["Society", "Hybrid"].includes(record.parking_type)  && record.rfid) ?
                        <DialogContent>
                            Are you sure you want to{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                {resolved === 1 ? 'Accept' : 'Decline'}
                            </span>{' '}
                            this request?
                        </DialogContent>
                        :
                        <SimpleForm style={{ padding: '10px 22px' }} toolbar={false}>
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 20 }}>
                                <div style={{ display: 'flex', alignItems: "center" }}>
                                    <img src={vehicleSvgs[record.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8, overflow:"visible" }} alt={record.vehicle_type_label} />
                                    <p style={{ fontFamily: "Poppins-Medium", color: "#707683", fontSize: 15, textTransform: "uppercase" }}>{record.vehicle_number}</p>

                                </div>

                                {
                                    record.chassis_number && record.chassis_number !== null && record.chassis_number !== "" && <div style={{ display: 'flex', alignItems: "center" }}>
                                        <p style={{ fontFamily: "Poppins-Medium", color: "#212121", fontSize: 15, marginRight: 8 }}>Chassis Number:</p>
                                        <p style={{ fontFamily: "Poppins-Medium", color: "#707683", fontSize: 15, textTransform: "uppercase" }}>{record.chassis_number}</p>
                                    </div>
                                }
                            </div>
                            <TextInput
                                source="access_key_id"
                                defaultValue={record.access_key_id}
                                style={{ display: 'none' }}
                            />

                            <div style={{ width: '100%' }}>

                                <>

                                    {record.paid === 1 && record.rfid_amount && record.rfid_request === 1 &&

                                        <div>
                                            <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>RFID Tag*</div>
                                            <RaAutocompleteInput
                                                source="rfid"
                                                resourceParam="search"
                                                resourcePath="rfidInventory"
                                                filter={{ available: true }}
                                                label=""
                                                getOptionValue={(option) => option['rfid']}
                                                getOptionLabel={(option) =>
                                                    `${option['tag_id']} - ${option['rfid']}`
                                                }
                                                useAccessKeyId={true}
                                                onSelect={(value) => setRfid(value)}
                                                style={{ marginTop: 7, marginBottom: 15 }}
                                            />
                                        </div >
                                    }



                                    {record.paid === 1 && record.nfc_id_request === 1 && record.nfc_amount &&
                                        <div style={{ width: "100%" }}>
                                            <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Select NFC Card*</div>
                                            <RaAutocompleteInput
                                                source="search"
                                                resourceParam="search"
                                                filter={{ available: true }}
                                                customSort={["surface_id", "ASC"]}
                                                resourcePath="cardsInventory"
                                                label=""
                                                getOptionValue={(option) => {
                                                    //setSurfaceId(option['surface_id'])
                                                    surfaceId.current = option['surface_id']
                                                    return option['nfc_uid']
                                                }}
                                                getOptionLabel={(option) =>
                                                    `${option['surface_id']} - ${option['nfc_uid']}`
                                                }
                                                onSelect={(value) => setSelectedOptions(value)}
                                                style={{ marginTop: 7, marginBottom: 15 }}
                                            />
                                        </div>}


                                </>


                                {
                                    record.parking_type !== "Society" &&

                                    <div>
                                        <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Email Address*</div>
                                        <MuiTextField
                                            variant='outlined'
                                            value={emailAddress}
                                            onChange={(e) => setEmailAddress(e.target.value)}
                                            size="small"
                                            style={{ marginBottom: 15, marginTop: 7 }}
                                        />
                                        <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Start Date*</div>

                                        <CustomDatePicker
                                            style={{ marginTop: 7, marginBottom: 15 }}
                                            startDate={startDate}
                                            setStartDate={(val) => setStartDate(val)}
                                        />
                                    </div>
                                }
                                <div style={{ width: "100%", borderBottom: "1px solid #DEDEDE" }}></div>

                                {/* <div
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: '80% 20%',
                                        justifyContent: 'space-around',
                                        alignItems: 'center',
                                        maxWidth: 500,
                                        marginTop: 20
                                    }}
                                >

                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        Monthly Pass Charges
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        ₹ {record.monthly_pass_amount}
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        RFID Tag Charges
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        ₹ {record.rfid_amount}
                                    </Typography>
                                    {
                                        record.nfc_id_request && record.nfc_amount &&
                                        <>
                                            <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                                NFC Card Charges
                                            </Typography>
                                            <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                                ₹ {record.nfc_amount}
                                            </Typography>
                                        </>
                                    }
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        Total
                                    </Typography>
                                    <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                                        ₹ {Number(record.rfid_amount) + Number(record.monthly_pass_amount) + Number(record.nfc_amount)}
                                    </Typography>
                                </div> */}
                            </div >
                        </SimpleForm >
                    }

                    <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={closeDialog} variant='contained' disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }}>Cancel</Button>
                        <Button
                            className={resolved !== 1 ? classes.errorText : null}
                            variant='contained'
                            onClick={handleUpdate}
                            disableElevation
                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", color: "#FFFF", backgroundColor: resolved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main, }}
                        >
                            {resolved === 1
                                ? 'Accept'
                                : 'Decline'}
                        </Button>
                    </DialogActions>
                </Dialog >
            </div >
        </>
    );
}